import { createFileRoute } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { supplyPointQueries } from '@/features/supply-points/queries';
import { SupplyPointSettingsPage } from '@/features/supply-points/pages/SupplyPointSettingsPage';
import { SettingsPageSkeleton } from '@/common/components/loading-skeleton/SettingsPageSkeleton';

export const Route = createFileRoute('/_authenticated/_supply-point-scope/settings')({
  component: SupplyPointSettingsPage,
  pendingComponent: SettingsPageSkeleton,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(supplyPointQueries.types());
    return { breadcrumb: t`Settings` };
  },
});
